var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"btn-gradient",attrs:{"depressed":"","dark":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-sync")]),_vm._v(" "+_vm._s(_vm.$t("btnUpgrade"))+" "),_c('v-icon',[_vm._v("mdi-chevron-down")])],1)]}}])},[_c('v-card',[_c('div',{staticClass:"text-h5"},[_vm._v("components here")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }